import { useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useQuery } from "react-query";
import useGlobalContext from "hooks/globalData";
import { ResponseCode } from "services/KnowfullyAdminClient";
import { CircularProgress } from "@mui/material";

const UserCertificateDeepLink = () => {
  const { userCertificateId } = useParams<{ userCertificateId: string }>();
  const {
    userCertificateService,
    userSkuCertificatesToolUrl,
    errorUrl,
  } = useGlobalContext();
  const navigate = useNavigate();

  const { data: userCertificate, isFetched } = useQuery(
    ["userCertificateService.getUserCertificate", userCertificateId],
    () => userCertificateService.getUserCertificate(userCertificateId!),
    { enabled: !!userCertificateId }
  );

  useEffect(() => {
    if (!isFetched) {
      return;
    }

    if (userCertificate?.responseCode === ResponseCode.OK) {
      navigate(
        userSkuCertificatesToolUrl(
          userCertificate.data?.userId,
          userCertificate.data?.userSkuId
        ),
        { replace: true }
      );
    } else {
      navigate(errorUrl(), { replace: true });
    }
  }, [
    isFetched,
    userCertificate,
    navigate,
    userSkuCertificatesToolUrl,
    errorUrl,
  ]);

  return <CircularProgress />;
};

export default UserCertificateDeepLink;
